import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "../common/constants/authUtil";

const PrivateRoute = ({ component: Component, ...rest }) => {
  // Function - Checkes if token exist
  const isAuthenticated = () => {
    let token = getToken();
    if (token) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated() ? <Redirect to="/login?autherror=true" /> : <Component {...props} />
      }
    />
  );
};

export default PrivateRoute;
